import { actionCreatorFactory } from 'typescript-fsa';

const actionCreator = actionCreatorFactory('timely/calendar');

export interface Selection {
  hourIds: Array<number>;
}

export type FilterSpan = 'day' | 'week' | 'month';

export enum Trigger {
  create_hour = 'create_hour',
}

export enum Ref {
  ta20_email = 'ta20_email',
}

// All possible UrlParameters for CalendarRoute
export interface UrlParameters {
  date: string;
  multiUserMode: boolean;
  userIds: Array<number>;
  trigger?: Trigger;
  start_time?: { hour: number; minute: number; raw: string };
  total_minutes?: number;
  /**
   * Use-case: Find TIC FullStories
   * @todo Remove after full TIC rollout.
   */
  tic?: true | undefined;
  /**
   * Use-case: Deep link to timesheet view from email reminders
   * When true, initializes calendar with timesheet proposal view active
   */
  timesheet?: boolean;
  ref?: Ref;
}

// RouteParameters from react-router for CalendarRoute
export interface RouteParameters {
  span: FilterSpan;
}

export type CombinedParameters = UrlParameters & RouteParameters;

interface ComputedFilter {
  isActingAsSelf: boolean;
  calendarUserId: number;
}

export type Filter = CombinedParameters & ComputedFilter;

interface SetSelectionProperty {
  key: string;
  value: any;
}

export const setSelectionProperty = actionCreator<SetSelectionProperty>('SET_SELECTION_PROPERTY');
export const setMemoryInboxVisibility = actionCreator<boolean>('SET_MEMORY_INBOX_VISIBILITY');
export const storeFilter = actionCreator<Partial<CombinedParameters>>('STORE_FILTER');
export const setBatchHourModalMode = actionCreator<BatchHourModalMode>('SET_BATCH_HOUR_MODAL_MODE');

export interface FetchStatus {
  fetchingSingle: boolean;
}

export interface State {
  fetchStatus: FetchStatus;
  selection: Selection;
  showMemoryInbox: boolean;
  // the last used calendar filter, used when navigating back to default /calendar route
  filter: Partial<CombinedParameters>;
  batchHourModalMode: BatchHourModalMode;
}

export enum CalendarViewMode {
  SOLO = 'solo',
  MULTI = 'multi',
}

export enum BatchHourModalMode {
  Copy = 'copy',
  Move = 'move',
}
